import { render, staticRenderFns } from "./AdsManagement.vue?vue&type=template&id=55d43dd5&"
import script from "./AdsManagement.vue?vue&type=script&lang=js&"
export * from "./AdsManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports